// Widget Scripts

import irishFestShop from './js/widgets/irishFestShop.js';
import mainFeatureSlide from './js/widgets/mainFeatureSlide.js';
import mainFeatureSlideMobile from './js/widgets/mainFeatureSlideMobile.js';
import cardSection from './js/widgets/cardSection.js';
import seoWidget from './js/widgets/seoWidget.js';
import hotButtons from './js/widgets/hotButtons.js';
import videoWidget from './js/widgets/videoWidget.js';




import sponsorsScroller from './js/widgets/sponsorsScroller.js';




// Custom Theme Scripts
import './js/localjs.js';
// Initialize Homepage Widgets

$(document).ready(function () {
  irishFestShop();
  });
if (window.location.pathname === '/') {
  $(document).ready(function () {
    mainFeatureSlide();
    mainFeatureSlideMobile();
    cardSection();
    seoWidget();
    hotButtons();

    $(window).load(function () {
     videoWidget();
    })



  });
};

$(document).ready(function () {
 sponsorsScroller();
})